var linkElementToAppendCSS = document.createElement('link');
linkElementToAppendCSS.href = '//inovafast.myshopify.com/cdn/shop/t/2/assets/parcelamento.css?v=92345602073641733491570501629';
linkElementToAppendCSS.type = 'text/css';
linkElementToAppendCSS.rel = 'stylesheet';
linkElementToAppendCSS.media = 'screen,print';
document.getElementsByTagName('head')[0].appendChild(linkElementToAppendCSS);

document.addEventListener('DOMContentLoaded', function(){
  if (window.location.href.indexOf('cart') != -1) {
    document.getElementById('frete').style.display='none';
  }
});



var writeInstallments = function(){
  
  
 
  var shop_installments = 3;  
  var installmentsText = "<span class='installments-plugin-snippet' style='display: none;font-weight:bold;font-family: sans-serif;text-transform: uppercase;font-size:83%;color:#000'><br />3x de &dividedPrice& <font style='font-weight:normal'> sem juros </font></span><div class='checkout-btns'><div id='row_btns_a' class='row_btn'><img data-img='visa' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/visa.svg?v=168040035931801853681570501631'><img data-img='master' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/master.svg?v=15667395479656974811570501628'><img data-img='amex' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/amex.svg?v=146829377703623274661570501621'><img data-img='hipercard' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/hipercard.svg?v=93310188086851652481570501626'><img data-img='dinners' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/dinners.svg?v=53706485292855968181570501623'><img data-img='elo' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/elo.svg?v=42898520462044191101570501624'><p id='parcelas_click'><img src='//inovafast.myshopify.com/cdn/shop/t/2/assets/down-arrow.svg?v=17954724648468410971570501624' /></p></div><div id='row_btns_c' style='display:none;'><ul class='col-lg-6'><li id='1x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=#101113>1x</FONT></li><li id='2x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>2x</FONT></li><li id='3x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>3x</FONT></li> <li id='4x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>4x</FONT></li> <li id='5x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>5x</FONT></li><li id='6x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>6x</FONT></li> </ul><ul class='col-lg-6'><li id='7x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>7x</FONT></li><li id='8x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>8x</FONT></li><li id='9x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>9x</FONT></li><li id='10x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>10x</FONT></li><li id='11x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>11x</FONT></li><li id='12x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>12x</FONT></li></ul></div><div id='row_btns_b' class='row_btn'><p class='boleto-icon'><img data-img='boleto' src='//inovafast.myshopify.com/cdn/shop/t/2/assets/boleto.svg?v=29042640155392895611570501621'><span class='parcelas'>R$ &price&</span></div></div></div>";
  var installmentsText2 = "<p class='frete-btn' style='margin-top:5px; text-align:center'><span id='frete'>&nbsp;&nbsp; Frete Grátis &nbsp;&nbsp;</span></p>";
  //var installmentsText3 = "<p style='margin-top:5px'><font style='font-size:96%;font-weight:normal'>ou R$ &price& à vista no Boleto Bancário</font></p>";
  var installmentsText3 = "<span class='installments-plugin-snippet' style='display: none;text-transform:uppercase;font-family: sans-serif;font-weight:bold;font-size:99%;color:#000'><br />ou  3x de &dividedPrice& <font style='font-weight:normal'> sem juros </font></span>";

  var installmentsTextMobile = "<span class='installments-plugin-snippet' style='display: none;padding-top:3px;font-size:87%;font-weight:bold'><br />3x de &dividedPrice& <font style='font-weight:bold'> sem juros </font></span>";
  var regexpToGetProductPrice = /\d*\.?\d+,?\d*/;

 
  // Gotta rename this function now that we are accepting more currencies
  function convertFloatToBrazilianPriceFormat(productPrice) {
    var productPriceInBRL;
    var currencySymbol;
    var mapObj = {
       ".":","
    };

    productPriceInBRL = productPrice.replace(/,|\./gi, function(matched){
      return mapObj[matched];
    });

    currencySymbol = (window.ShopifyAnalytics.meta.currency === 'BRL' ? 'R$ ' : '$ ')

    return currencySymbol + productPriceInBRL;
  }

  function convertPriceToUsFormat(productPrice) {
    var mapObj = {
       ".":"",
       ",":"."
    };

    productPrice = productPrice.replace(/,|\./gi, function(matched){
      return mapObj[matched];
    });

    return parseFloat(productPrice)
  }

  function isGreaterThanZero(regexpMatch) {
    return regexpMatch !== null && regexpMatch[0] !== '0,00' && regexpMatch[0] !== '0.00' && regexpMatch[0] !== '0'
  }

  function currencyUsesCommaAsCentsDivision() {
    return (window.ShopifyAnalytics.meta.currency === 'BRL') || (window.ShopifyAnalytics.meta.currency === 'ARS')
  }

  
  
  function installmentsHtml(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);

    return [installmentsText.replace('&price&', productPrice).replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice)), installmentsText2.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice))];
    
  }
  
  function installmentsHtmlCart(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);
    return [installmentsText3.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice))];
    
  }
  
  
  
  
  function installmentsHtmlMobile(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);

    return installmentsTextMobile.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice));
  }

  function textOutsideTags($element) {
    return $element.clone()
      .children()
      .remove()
      .end()
      .text();
  }

  
// Home || Catalog || Recommended Products || Search
if ($('.grid-view-item span.product-price__price').length) {
  $('.grid-view-item span.product-price__price').each(function() {
    var regexpMatch = textOutsideTags($(this)).match(regexpToGetProductPrice);

    if (isGreaterThanZero(regexpMatch)) {
      var productPrice = regexpMatch[0];
      $(this).parent().append(installmentsHtmlMobile(productPrice));
    }
  });
}


// Product page || Featured page
function addInstallmentsPriceToProductPage($productPrice) {
  $productPrice = $('.product-single__meta .product-price__price > span:not(.save_discount_pro, .per_discount, #ComparePrice-product-template, .sale-tag)');

  $productPrice.each(function() {
    
    $this = $(this);
    var regexpMatch = $this.text().match(regexpToGetProductPrice)[0]; 
    if (isGreaterThanZero(regexpMatch)) {
      $this.parent().parent().append(installmentsHtml(regexpMatch));
    }
    
    $("#row_btns_a").click(function(){
      $("#row_btns_c").toggle("slow");
    });
    
    var total = parseFloat(regexpMatch.replace("R$", "").replace(",","."));    
    
    for (var i = 0; i < 13; i++) {
      console.log(total/i);
      if (i < 4) {
        $("#"+i+"x").append("<span> de R$ "+(total/i).toFixed(2).toString().replace(".",",")+" sem juros</span>");
      } 
      else {
        $("#"+i+"x").append("<span> de R$ "+(total/i).toFixed(2).toString().replace(".",",")+" com juros</span>");
      }
       
    }
    
  });
}

  
  
if ($('.product-single__meta').length) {
  
  
  
  addInstallmentsPriceToProductPage();
  
 
  $('.product-single__meta .product-price__price').on('DOMSubtreeModified', '> span:not(.save_discount_pro, .per_discount)', function(){
    setTimeout(
    function()
    {
      $('.product-single__meta .installments-plugin-snippet').remove();
      addInstallmentsPriceToProductPage();
    }, 100);
  });
  
  
}

// Cart page
if ($('body.template-cart').length) {
  var $productPrice = $('.cart__subtotal .crt_total .wh-cart-total');
  var regexpMatch = $productPrice.text().match(regexpToGetProductPrice);

  if (isGreaterThanZero(regexpMatch)) {
    var price = regexpMatch[0];
    $productPrice.parent().parent().append(installmentsHtmlCart(price));
  } else {
  	var $productPrice = $('.cart__subtotal .crt_total');
  	var regexpMatch = $productPrice.text().match(regexpToGetProductPrice);
    var price = regexpMatch[0];
    $productPrice.parent().parent().append(installmentsHtmlCart(price));
  }
  
}
  
  
  
};




if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {    
  writeInstallments();      
} else {    
  document.addEventListener("onreadystatechange", writeInstallments);      
}

